import { ContactSearch } from '@/components/pages';

const SearchContactsRoute = () => <ContactSearch />;

export default SearchContactsRoute;
